// 目标管理模块配置
export const goalsConfig = {
  // 模块基本信息
  name: '目标管理',
  description: '设定、分解、执行、监督',
  icon: 'TargetOutlined',
  bgColor: '#722ED1',
  iconColor: '#FFFFFF',
  
  // API 端点
  apiEndpoints: {
    goals: '/goals',
    create: '/goals',
    update: '/goals',
    delete: '/goals',
    progress: '/goals/progress',
    addProgress: '/goals/progress',
    deleteProgress: '/goals/progress',
    types: '/goals/types',
    createType: '/goals/types',
    updateType: '/goals/types',
    deleteType: '/goals/types',
    stats: '/goals/stats'
  },
  
  // 目标类型
  goalTypes: [
    {
      key: 'career',
      name: '职业发展',
      icon: '💼',
      color: '#1890FF',
      description: '工作技能提升、职位晋升、职业规划'
    },
    {
      key: 'study',
      name: '学习成长',
      icon: '📚',
      color: '#52C41A',
      description: '知识学习、技能掌握、证书考取'
    },
    {
      key: 'health',
      name: '健康管理',
      icon: '🏃',
      color: '#FF6B6B',
      description: '运动健身、饮食管理、心理健康'
    },
    {
      key: 'finance',
      name: '财务管理',
      icon: '💰',
      color: '#FAAD14',
      description: '理财投资、储蓄计划、财务自由'
    },
    {
      key: 'relationship',
      name: '人际关系',
      icon: '👥',
      color: '#722ED1',
      description: '社交技能、人际关系维护、团队合作'
    },
    {
      key: 'personal',
      name: '个人成长',
      icon: '🌟',
      color: '#13C2C2',
      description: '自我提升、兴趣爱好、生活品质'
    }
  ],
  
  // 目标状态
  goalStatus: [
    {
      key: 'planning',
      name: '规划中',
      color: '#D9D9D9',
      description: '目标正在制定和规划阶段'
    },
    {
      key: 'active',
      name: '进行中',
      color: '#1890FF',
      description: '目标正在执行中'
    },
    {
      key: 'completed',
      name: '已完成',
      color: '#52C41A',
      description: '目标已经完成'
    },
    {
      key: 'paused',
      name: '暂停中',
      color: '#FAAD14',
      description: '目标暂时停止执行'
    },
    {
      key: 'cancelled',
      name: '已取消',
      color: '#FF4D4F',
      description: '目标已取消'
    }
  ],
  
  // 优先级
  priorities: [
    {
      key: 'high',
      name: '高优先级',
      color: '#FF4D4F',
      description: '重要且紧急'
    },
    {
      key: 'medium',
      name: '中优先级',
      color: '#FAAD14',
      description: '重要但不紧急'
    },
    {
      key: 'low',
      name: '低优先级',
      color: '#52C41A',
      description: '不重要但紧急'
    }
  ],
  
  // SMART原则
  smartPrinciples: {
    title: 'SMART目标设定原则',
    description: '设定目标时遵循SMART原则，确保目标的有效性和可执行性',
    principles: [
      {
        letter: 'S',
        name: 'Specific（具体）',
        description: '目标要具体明确，避免模糊不清',
        example: '❌ 我要减肥\n✅ 我要在3个月内减重10公斤'
      },
      {
        letter: 'M',
        name: 'Measurable（可衡量）',
        description: '目标要有明确的衡量标准',
        example: '❌ 我要提高英语水平\n✅ 我要在6个月内通过雅思考试，达到6.5分'
      },
      {
        letter: 'A',
        name: 'Achievable（可实现）',
        description: '目标要在能力范围内，具有挑战性但不脱离实际',
        example: '❌ 我要在1个月内成为百万富翁\n✅ 我要在1年内通过副业赚取10万元'
      },
      {
        letter: 'R',
        name: 'Relevant（相关）',
        description: '目标要与个人价值观和长期规划相关',
        example: '❌ 我要学会弹钢琴（与职业无关）\n✅ 我要学会数据分析（提升职业竞争力）'
      },
      {
        letter: 'T',
        name: 'Time-bound（有时限）',
        description: '目标要有明确的时间期限',
        example: '❌ 我要学会编程\n✅ 我要在3个月内学会Python基础编程'
      }
    ]
  },
  
  // 目标设定TIPS
  goalSettingTips: {
    title: '目标设定小TIPS',
    tips: [
      {
        title: '设定目标',
        description: '使用 SMART 原则（具体、可衡量、可实现、相关、有时限）',
        example: '3 个月内完成 10 本书的阅读笔记'
      },
      {
        title: '分解目标',
        description: '把大目标拆成小目标',
        example: '每周读完 1 本书，每天读 30 页'
      },
      {
        title: '制定计划并执行',
        description: '制定时间表，按阶段执行',
        example: '每天晚上 8 点固定学习 1 小时'
      },
      {
        title: '监督与反馈',
        description: '定期检查进度，总结问题',
        example: '每周检查阅读量，不足就调整'
      },
      {
        title: '评价与改进',
        description: '完成后进行总结，记录经验',
        example: '发现某些书难度高 → 下次目标分配时考虑难度'
      }
    ]
  },
  
  // 目标管理流程
  goalManagementProcess: {
    title: '目标管理五大流程',
    process: [
      {
        step: 1,
        title: '目标设定',
        description: '明确目标，使用SMART原则',
        icon: '🎯',
        color: '#1890FF'
      },
      {
        step: 2,
        title: '计划分解',
        description: '将大目标分解为小任务',
        icon: '📋',
        color: '#52C41A'
      },
      {
        step: 3,
        title: '执行跟踪',
        description: '按计划执行，定期跟踪进度',
        icon: '📈',
        color: '#FAAD14'
      },
      {
        step: 4,
        title: '监督反馈',
        description: '定期检查，及时调整',
        icon: '👀',
        color: '#722ED1'
      },
      {
        step: 5,
        title: '评价奖励',
        description: '总结评价，给予奖励',
        icon: '🏆',
        color: '#FF6B6B'
      }
    ]
  },
  
  // 进度模板
  progressTemplates: {
    title: '进度记录模板',
    templates: [
      {
        title: '学习类目标',
        template: '今日学习了{内容}，用时{时间}，掌握了{知识点}，遇到困难{问题}，明日计划{计划}'
      },
      {
        title: '工作类目标',
        template: '今日完成了{任务}，进度{百分比}%，遇到的问题{问题}，解决方案{方案}，明日重点{重点}'
      },
      {
        title: '健康类目标',
        template: '今日运动{项目}，时长{时间}，感受{感受}，饮食{记录}，睡眠{质量}，明日目标{目标}'
      },
      {
        title: '通用模板',
        template: '今日进展{进展}，完成度{百分比}%，遇到的问题{问题}，解决方案{方案}，明日计划{计划}'
      }
    ]
  },
  
  // 奖励建议
  rewardSuggestions: {
    title: '奖励建议',
    suggestions: [
      {
        category: '物质奖励',
        items: [
          '购买心仪已久的物品',
          '享受一顿美食',
          '购买书籍或课程',
          '旅行或短途出行'
        ]
      },
      {
        category: '精神奖励',
        items: [
          '给自己一个休息日',
          '做自己喜欢的事情',
          '与朋友分享成就',
          '记录成功日记'
        ]
      },
      {
        category: '成长奖励',
        items: [
          '学习新技能',
          '参加培训课程',
          '阅读好书',
          '尝试新体验'
        ]
      }
    ]
  }
};
